import {
    type interfaces,
    ContainerModule,
} from '@patsnap/tahiti-core/shared/inversify';

// Apis
import { GeneralFileUploadApiImpl } from './apis/impls/general-file-upload-api';
import { GeneralFileUploadApi } from './apis/general-file-upload-api';

export const generalFileUploadModule = new ContainerModule((bind: interfaces.Bind) => {
    // Bind Apis
    bind(GeneralFileUploadApi).to(GeneralFileUploadApiImpl).inSingletonScope();
});

// Re-export types and constants
export * from './types';
export * from './constants';
export * from './apis/general-file-upload-api';
